import "./AndroidDownloadFloatingButton.css";

export default function AndroidDownloadFloatingButton({ onClick }) {
    return (
        <button
            type="button"
            className="android-floating-download"
            onClick={onClick}
            aria-label="Download Android App"
        >
            <span className="android-floating-tooltip">
                Download Android App
            </span>

            <i className="fa-brands fa-android"></i>
        </button>
    );
}
